import { Text, TableRow, TableCell } from 'braid-design-system';
import { type GraphQLType, getNamedType } from 'graphql';

import { TypeLink } from '#src/components/TypeLink/TypeLink.tsx';

import { SchemaMarkdown } from './SchemaMarkdown.tsx';

interface Props {
  type: GraphQLType;
}

/**
 * Renders an inline snippet of a type with a type link
 *
 * This is intended when for situations like interface implementation lists
 * where we want more than the link but not the full details.
 */
export const TypeSnippet = ({ type }: Props) => {
  const namedType = getNamedType(type);

  return (
    <TableRow>
      <TableCell width="content">
        <Text>
          <TypeLink type={type} />
        </Text>
      </TableCell>
      <TableCell wrap>
        <SchemaMarkdown type={namedType.name} />
      </TableCell>
    </TableRow>
  );
};
